// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import WYSIWYGEditor from '../../../../../shared-components/WYSIWYGEditor';
import CapstoneLureArray from './components/CapstoneLureArray';
import CapstoneFeedbackArray from './components/CapstoneFeedbackArray';

const FPECapstoneResponse = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir, possiblePages } = props;

  return (
    <div>
      <NumberedHeading
        number="1"
        title="Prompt"
        instructions="Enter the Part 1 prompt in the target language."
      />
      <Controller
        control={control}
        name="content.section.prompt"
        render={({ field }) => (
          <WYSIWYGEditor {...field} error={errors.content?.core?.prompt_tl} />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading
        number="2"
        title="Prompt"
        instructions="Enter the Part 1 prompt in the target language."
      />
      <Controller
        control={control}
        name="content.section.lures"
        render={({ field }) => (
          <CapstoneLureArray inputDir={inputDir} {...{ control, errors }} />
        )}
      />

      <NumberedHeading
        number="3"
        title="Prompt (TL)"
        instructions="Enter the Part 2 prompt in the target language"
      />
      <Controller
        control={control}
        name="content.core.prompt_tl"
        render={({ field }) => (
          <WYSIWYGEditor {...field} error={errors.content?.core?.prompt_tl} />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading
        number="4"
        title="Prompt (EN)"
        instructions="Enter the Part 2 prompt in the target language"
      />
      <Controller
        control={control}
        name="content.core.prompt_en"
        render={({ field }) => (
          <WYSIWYGEditor {...field} error={errors.content?.core?.prompt_en} />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading
        number="5"
        title="Response"
        instructions="Write the schoolhouse response that will be shown to the student to let them know what their response could have looked like."
      />
      <Controller
        control={control}
        name="content.core.response"
        render={({ field }) => (
          <WYSIWYGEditor {...field} error={errors.content?.core?.response} />
        )}
      />

      <NumberedHeading
        number="6"
        title="Notebook Snippets"
        instructions="Using the controls below, add the page ids for the completion events."
      />
      <Controller
        control={control}
        name="content.notebook"
        render={({ field }) => (
          <CapstoneFeedbackArray
            inputDir={inputDir}
            {...{ control, errors }}
            possiblePages={possiblePages}
          />
        )}
      />
    </div>
  );
};

export default FPECapstoneResponse;
